import React from 'react';
import { FadeIn, Section, Button } from './ui';
export function FinalCTASection() {
  return <Section variant="black" className="pb-8" data-id="element-114">
      <FadeIn data-id="element-115">
        <div className="text-center mb-10" data-id="element-116">
          <h2 className="text-3xl md:text-4xl font-black text-white mb-6 leading-tight" data-id="element-117">
            El lunes que viene podés entrar al aula con un sistema. O podés
            seguir improvisando.
          </h2>
          <p className="text-gray-400 text-base md:text-lg max-w-[600px] mx-auto leading-relaxed mb-4" data-id="element-118">
            Cada semana que pasa sin un sistema es otra semana de clases que
            podrían haber sido mejores, otro domingo de estrés innecesario, otro
            reclamo de padre que te podría haber evitado.
          </p>
          <p className="text-white font-bold text-lg md:text-xl" data-id="element-119">
            Matemática 360 no te promete que la docencia va a ser fácil. Te
            promete que va a ser más tuya.
          </p>
        </div>

        <div className="flex flex-col md:flex-row gap-4 justify-center mb-8" data-id="element-120">
          <Button href="#pricing" variant="primary" className="md:w-[300px]" data-id="element-121">
            <span data-id="element-122">SISTEMA BASE — $19.990 →</span>
            <span className="text-xs font-normal text-white/80 mt-1" data-id="element-123">
              6 Tomos + 3 Bonus · Descarga inmediata
            </span>
          </Button>

          <Button href="#pricing" variant="gold" className="md:w-[300px]" data-id="element-124">
            <span data-id="element-125">ELITE BUNDLE — $29.990 👑</span>
            <span className="text-xs font-normal text-black/70 mt-1" data-id="element-126">
              Todo el Sistema Base + Diplomacia + Marca
            </span>
          </Button>
        </div>

        <div className="text-center text-xs md:text-sm text-gray-500 flex flex-wrap justify-center gap-x-4 gap-y-2 mb-16" data-id="element-127">
          <span data-id="element-128">🔒 Pago seguro</span>
          <span className="hidden md:inline" data-id="element-129">·</span>
          <span data-id="element-130">✅ Descarga inmediata</span>
          <span className="hidden md:inline" data-id="element-131">·</span>
          <span data-id="element-132">🛡️ Garantía 7 días</span>
          <span className="hidden md:inline" data-id="element-133">·</span>
          <span data-id="element-134">📱 Compatible con celular</span>
        </div>

        <footer className="border-t border-gray-800 pt-8 text-center text-xs text-gray-600" data-id="element-135">
          <p data-id="element-136">
            © Matemática 360 · Argentina 2024 · Todos los derechos reservados
          </p>
          <p className="mt-1" data-id="element-137">
            Producto digital · Solo uso personal del comprador
          </p>
        </footer>
      </FadeIn>
    </Section>;
}